import config from "./config.json";

type ConfigKeyType = keyof typeof config;

type AppConfigFunction = (configKey: ConfigKeyType) => any;

const appConfig: AppConfigFunction = (configKey) => config[configKey];

export default appConfig;
